import {createAction, props} from '@ngrx/store';
import {TableSettings} from '../../interfaces/table-setting.interface';
import {DateFilterData} from '../../interfaces/date-filter-data.interface';
import {FaelligkeitsSchnellauswahl} from '../../interfaces/faelligkeits-schnellauswahl.enum';

export class ZahlungenTableActions {
  /*
   * INFO: Table Settings Actions
   */

  public static changeTableSettings = createAction(
    '[Overview Table] Changed table settings.',
    props<{tableSettings: TableSettings}>(),
  );

  public static setAusfuehrungsdatumUserActive = createAction(
    '[Overview Table] Set Ausfuehrungsdatum user active.',
    props<{active: boolean}>(),
  );

  /*
   * INFO: Selection Actions (ID-basiert)
   */

  public static toggleZahlungSelection = createAction(
    '[Overview Table] Toggle zahlung selection.',
    props<{zahlungId: string}>(),
  );

  public static selectAllZahlungen = createAction(
    '[Overview Table] Select all zahlungen.',
    props<{selectableIds: string[]}>(),
  );

  public static unselectAllZahlungen = createAction('[Overview Table] Unselect all zahlungen.');

  /*
   * INFO: Filter Actions
   */

  public static showFilter = createAction('[Overview Table] Show filter panel.');

  public static hideFilter = createAction('[Overview Table] Hide filter panel.');

  public static updateSearchFilter = createAction(
    '[Overview Table] Updates the search value.',
    props<{searchValue: string}>(),
  );

  public static updateFaelligkeitsSchnellauswahlFilter = createAction(
    '[Overview Table] Updates the Faelligkeits-Schnellauswahl value.',
    props<{auswahl: FaelligkeitsSchnellauswahl | undefined}>(),
  );

  public static updateFaelligkeitsdatumFilter = createAction(
    '[Overview Table] Updates the Faelligkeitsdatum value.',
    props<{dateFilter: DateFilterData}>(),
  );

  public static updateAusfuehrungsdatumFilter = createAction(
    '[Overview Table] Updates the Ausfuehrungsdatum value.',
    props<{dateFilter: DateFilterData}>(),
  );

  public static setBetragVonFilter = createAction(
    '[Overview Table] Set betragVon filter.',
    props<{betragVon: number | undefined}>(),
  );

  public static setBetragBisFilter = createAction(
    '[Overview Table] Set betragBis filter.',
    props<{betragBis: number | undefined}>(),
  );

  public static resetSingleFilter = createAction(
    '[Overview Table] Resets a single filter by id.',
    props<{id: string}>(),
  );

  public static resetAllFilter = createAction('[Overview Table] Resets all filter.');
}
